import Breadcrumb from "components/shared/breadcrumb";
import { memo, useContext, useEffect, useMemo, useState } from "react"
import FinancialReport from "./financial-report";
import Chart from "./chart";
import UseFetch from "hooks/useFetch";
import FinancialState from "./financial-state";
import OrderState from "./order-state";
import ContentState from "./content-state";
import InitializeContext from "context/initialize-context";
import { checkPermission } from "utils";
import Skeleton from "./skeleton";

const Dashboard = () => {
    const enums = useContext(InitializeContext);
    const [fetchUrl, setFetchUrl] = useState(null);
    const { data, isLoading, error } = UseFetch(fetchUrl);

    const dashboardPermission = useMemo(() => {
        return checkPermission(["/api/summary/dashboard"], enums.permissions);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (dashboardPermission)
            setFetchUrl("/api/summary/dashboard");
    }, [dashboardPermission])

    return (
        <div className="m-container dashboard">
            <div className="flex item-start md:items-center justify-start md:justify-between flex-col md:flex-row mb-10">
                <div className="mb-6 md:mb-0">
                    <h1 className="title-c1 tp-21">داشبورد</h1>

                    <Breadcrumb data={[
                        { title: "داشبورد" }
                    ]} />
                </div>
            </div>

            {
                dashboardPermission && (
                    !isLoading ? (
                        !error ? (
                            <div className="grid grid-cols-12 gap-4">
                                <div className="col-span-full xl:col-span-8">
                                    <div className="top-msg mb-4">
                                        <div className="grid grid-cols-12 gap-4 w-full">
                                            <div className="col-span-8">
                                                <h2 className="font-bold text-white mb-4">خوش آمدید!</h2>
                                                <p className="md:text-slate-300 text-xs text-primary-100">
                                                    بهترین ها را گرد هم آورده ایم تا بتوانیم در کنارهم، برترین اجناس حوزه خود را به کاربران سراسر وب معرفی نماییم. در صورت نیاز به اطلاعات بیشتر می توانید از منو راهنما و آموزش استفاده نمایید.
                                                </p>
                                            </div>

                                            <div className="col-span-4">
                                                <img src="/assets/image/dashboard-vc-kgj.png" alt="dashboard vector" />
                                            </div>
                                        </div>
                                    </div>

                                    <FinancialReport data={data} />
                                    <Chart data={data} />
                                </div>

                                <div className="col-span-full xl:col-span-4">
                                    <FinancialState data={data} />
                                    <OrderState data={data} />
                                    <ContentState data={data} />
                                </div>
                            </div>
                        ) : <p className="global-error">خطای سیستم !</p>
                    ) : <Skeleton />
                )
            }
        </div>
    )
}

export default memo(Dashboard);